/**
 * Native-auth breadcrumb telemetry (Jun 2026 diagnosis layer).
 * Fire-and-forget; never blocks or throws. Read from
 * db.native_auth_debug to pinpoint exactly where the Android Google
 * login chain breaks on a real device (24h retention).
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function crumb(event, handoffId = null, meta = null) {
  try {
    axios.post(
      `${API_URL}/api/auth/native-debug`,
      { event, handoff_id: handoffId, meta },
      { timeout: 5000 }
    ).catch(() => {});
  } catch (_) { /* never break the auth flow for telemetry */ }
}
